import React from "react";
import { Box, Container, Stack, Typography } from "@mui/material";
import UpgradeNotice from "../../shared/UpgradeNotice";

const IncomeManagementUpgradeNotice = () => (
    <Box
        sx={{
            py: { xs: 6, md: 10 },
            px: 2,
            background: "linear-gradient(135deg, rgba(255,165,0,0.12) 0%, rgba(0,0,0,0.06) 100%)",
            minHeight: "100vh",
        }}
    >
        <Container maxWidth="md">
            <Stack spacing={2} alignItems="flex-start">
                <Typography variant="h4" fontWeight={800}>
                    Einnahmenverwaltung
                </Typography>
                <Typography color="text.secondary">
                    Buchhaltungsfunktionen sind im 20 € netto Tarif enthalten.
                </Typography>
                <UpgradeNotice
                    title="Einnahmenverwaltung freischalten"
                    description="Die Einnahmenverwaltung inklusive Upload & OCR ist Teil des Buchhaltungstarifs."
                    actionLabel="Zum Buchhaltungstarif"
                />
            </Stack>
        </Container>
    </Box>
);

export default IncomeManagementUpgradeNotice;
